import React from "react";
import Logo from "../../../assets/images/logo.png";

const Footer = () => {
	let currentYear = new Date().getFullYear();
	return (
		<div className="footer-container">
			<div className="img-wrapper">
				<img
					src={Logo}
					alt="logo"
				/>
			</div>
			<div className="social-media-link-wrapper">
				<a href="http://">
					<i className="fab fa-facebook"></i>
				</a>
				<a href="http://">
					<i className="fab fa-twitter"></i>
				</a>
				<a href="http://">
					<i className="fab fa-youtube"></i>
				</a>
				<a href="http://">
					<i className="fab fa-instagram"></i>
				</a>
			</div>
			<h2 className="footer-last-title">
				tariqat.org
			</h2>
			<h3 className="footer-last-title">
				<b>© {currentYear}</b> Tariqat Media, Darul Ehsan Educational & Charitable Trust. All Rights Reserved.
			</h3>
		</div>
	);
};

export default Footer;
